<template>
    <AlternateFormAddress
        v-bind="$attrs"
        :disabled-fields="disableStreetAndCity ? ['street', 'city'] : []"
        :hidden-fields="hideStreetAndCity ? ['street', 'city'] : []"
        v-on="$listeners"
        @blur="handleAddressBlur"
    />
</template>

<script>
import AlternateFormAddress from './AlternateFormAddress';
import { validZipCode, validHouseNumber } from '@/utils/validation';

export default {
    name: 'AlternateFormAddressWithZipCodeLookup',
    components: { AlternateFormAddress },
    inheritAttrs: false,
    props: {
        gameId: {
            type: String,
            required: true,
        },
    },
    data() {
        const { zipCode, houseNr } = this.$attrs?.value ?? {};
        const hideAndDisable = !zipCode || !houseNr;

        return {
            hideStreetAndCity: hideAndDisable,
            disableStreetAndCity: hideAndDisable,
            cache: {},
        };
    },
    methods: {
        handleAddressBlur(event) {
            const inputName = event.target.name;
            const { zipCode, houseNr } = this.$attrs.value;

            // Return if this blur event is not for the zipCode or houseNr input
            if (inputName !== 'zipCode' && inputName !== 'houseNr') {
                return;
            }

            // Show street and city field upon blur
            this.hideStreetAndCity = false;

            // Lookup address if the zip code and house number values are valid
            if (validZipCode(zipCode) && validHouseNumber(houseNr)) {
                this.lookup(zipCode, houseNr);
            } else {
                this.resetValue();

                // Hide street and city if input is invalid
                this.hideStreetAndCity = true;
            }
        },
        lookup(zipCode, houseNr) {
            // Check cache first before firing request
            const cachedResult = this.getFromCache(zipCode, houseNr);
            if (cachedResult) {
                this.processResult(zipCode, houseNr, cachedResult);
                return;
            }

            this.$api?.zipCodeLookupDebounced(this.gameId, zipCode, houseNr).then(data => {
                this.processResult(zipCode, houseNr, data);
            });
        },
        processResult(zipCode, houseNr, data) {
            this.disableStreetAndCity = data.ok;
            const { street = '', city = '' } = data?.result ?? {};

            this.addToCache(zipCode, houseNr, data);
            this.updateValue({ street, city });
        },
        resetValue() {
            this.updateValue({ street: '', city: '' });
        },
        updateValue({ street, city }) {
            this.$attrs.value.street = street;
            this.$attrs.value.city = city;
        },
        getFromCache(zipCode, houseNr) {
            return this.cache?.[this.createCacheKey(zipCode, houseNr)];
        },
        addToCache(zipCode, houseNr, value) {
            this.cache[this.createCacheKey(zipCode, houseNr)] = value;
        },
        createCacheKey(zipCode, houseNr) {
            return `${zipCode}-${houseNr}`;
        },
    },
};
</script>

<style></style>
